<template>
  <div class="text-center py-24 text-gray-500 dark:text-slate-400">
    <p>No existen registros …</p>
  </div>
</template>
